import React from 'react'
import { ResponsiveTableRow, DataBlock, Separator, colors } from '@fs/zion-ui'
import { ContactChip } from '@fs/zion-contact-overlay'
import { css } from '@emotion/core'
import { getImage, getReadableOpCode, useSlsStateContext } from '@fs/zion-sls'
import { converTimestampToDate, getChangeValues } from '../utils'

const labelColorCss = css`
  color: ${colors.gray70};
`

const valueColumnCss = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
`

const renderChangeValues = (change, types, noHeadingOnValue) => {
  const value = getChangeValues({ action: change, slsTypes: types })

  return noHeadingOnValue ? (
    <span css={valueColumnCss} title={value}>
      {value}
    </span>
  ) : (
    <DataBlock heading={`${change?.displayLabel}:`} data={value} />
  )
}

const getUser = (userId) => {
  if (userId?.startsWith('fs:')) userId = 'cis.wkca.MMMM-M932'
  return <ContactChip contact={{ cisId: userId }} />
}

const ChangeHistoryRow = ({ change, noHeadingOnValue = false, ...props }) => {
  const state = useSlsStateContext()
  const currentImage = getImage(state?.images, state?.currentImageArk) || {}

  return (
    <ResponsiveTableRow
      {...props}
      column1={<span css={labelColorCss}>{getReadableOpCode(change, currentImage?.actions, state.types)}</span>}
      column2={renderChangeValues(change, state.types, noHeadingOnValue)}
      column3={
        <>
          {converTimestampToDate(change?.journalAttribution?.timestamp)}
          <Separator size="xxs" />
          {getUser(change?.journalAttribution?.userId)}
        </>
      }
    />
  )
}

export default ChangeHistoryRow
